module.exports = __webpack_public_path__ + "img/adobe-commerce-vs-magento.cccfd343.jpg";